export const state = {
  atividadeOs: {
    id: "",
    ordem_servico_id: "",
    data_inicio: "",
    data_termino: "",
    tecnico_id: "",
    descricao: "",
    concluida: false,
    horario_inicio: "",
    horario_termino: "",
  },
  atividadesOs: [],
  modalCadastroAtividadeOs: false,
  modalExcluirAtividadeOs: false,
};

export default {};
